<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class=" font-weight-bold text-capitalize light--text" color="primary"> <v-icon class="me-1" small>mdi-plus</v-icon> Add </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Add FAQ Question</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="mt-2">
            <v-form @submit="createFaq()" v-model="valid" ref="form">
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <h4 class="text-body-2 dark--text">Question En</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-textarea solo name="input-7-4" label="QuestionAr" v-model="question" :rules="[requiredValidator('question En')]"></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <h4 class="text-body-2 dark--text">Question Ar</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-textarea solo name="input-7-4" label="QuestionAr" v-model="questionAr" :rules="[requiredValidator('question Ar')]"></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <h4 class="text-body-2 dark--text">Answer En</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-textarea solo name="input-7-4" label="Answer En" v-model="answer" :rules="[requiredValidator('answer En')]"></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <h4 class="text-body-2 dark--text">Answer Ar</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-textarea solo name="input-7-4" label="Answer Ar" v-model="answerAr" :rules="[requiredValidator('answer Ar')]"></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <h4 class="text-body-2 dark--text">Active</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-radio-group v-model="active" :mandatory="false" row>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm2 md2>
                  <h4 class="text-body-2 dark--text">Show Order</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-text-field :rules="[requiredValidator('order')]" solo dense @keypress="isNumber" label="Show Order" type="number" v-model="showOrder" min="0"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-end mt-n8">
          <v-btn color="primary" class="mb-2 light--text mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="createFaq" :loading="btnloading" :disabled="!valid">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";

export default {
  data() {
    return {
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      question: "",
      answer: "",
      showOrder: 0,
      active: true,
      show_dialog_box: false,
      requiredValidator: requiredValidator,
    };
  },
  methods: {
    close() {
      this.show_dialog_box = false;
    },
    createFaq() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("@/faq/api/createFaq.graphql"),
          variables: {
            question: this.question,
            questionAr: this.questionAr,
            answer: this.answer,
            answerAr: this.answerAr,
            active: this.active,
            showOrder: this.showOrder,
          },
          update: (store, { data: { createFaq } }) => {
            try {
              const query = {
                query: require("@/faq/api/getAllFaqs.graphql"),
                variables: {
                  limit: 25,
                  skip: 0,
                },
              };

              let allFaqs = store.readQuery(query);

              allFaqs.getAllFaqs.faqs.unshift(createFaq); //push to top
              store.writeQuery({
                ...query,
                data: allFaqs,
              });

              this.text = "FAQ Added";
              this.snackbar = true;
              this.btnloading = false;
              this.show_dialog_box = false;
              this.$refs.form.reset();
            } catch (e) {
              console.log("Something bad happend- FaqForm.vue");
              console.log(e);
              this.btnloading = false;
            }

            this.show_dialog_box = false;
            this.btnloading = false;
          },
        })

        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
          this.show_dialog_box = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
